
import Box from '@mui/material/Box';
import banner2 from '../../../src/assets/illustrations/banner2.png';
import CardMedia from '@mui/material/CardMedia';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import banner3 from '../../../src/assets/illustrations/banner3.png';
import banner4 from '../../../src/assets/illustrations/banner4.png';
import banner2_responsive from '../../../src/assets/illustrations/banner2_responsive.png';
import banner3_responsive from '../../../src/assets/illustrations/banner3_responsive.png';
import banner4_responsive from '../../../src/assets/illustrations/banner4_responsive.png';
//imagenes español
import banner2_espanol from '../../../src/assets/illustrations/es/banner2_espanol.png';
import banner2_espanol_movil from '../../../src/assets/illustrations/es/banner2_espanol_movil.png';
import banner3_espanol from '../../../src/assets/illustrations/es/banner3_espanol.png';
import banner3_espanol_movil from '../../../src/assets/illustrations/es/banner3_espanol_movil.png';
//redux
import { useSelector } from 'redux/store';

import Iconify from '../../../src/components/Iconify';
import useResponsive from 'hooks/useResponsive';
import { Typography } from '@mui/material';

export default function Banners() {
    const { environment } = useSelector((state) => state.nuDetectState);
    const isDesktop = useResponsive('up', 'sm');

    const banner_2 = (environment.language === "es") ? banner2_espanol : banner2;
    const banner_2_movil = (environment.language === "es") ? banner2_espanol_movil : banner2_responsive;
    const banner_3 = (environment.language === "es") ? banner3_espanol : banner3;
    const banner_3_movil = (environment.language === "es") ? banner3_espanol_movil : banner3_responsive;




    return (
        <>
            <Box mt={3}>
                <Card>
                    {isDesktop && (
                        <CardMedia image={banner_2} sx={{ position: 'relative', paddingTop: '33%' }} />
                    ) ||
                        (<CardMedia image={banner_2_movil} sx={{ position: 'relative', paddingTop: '33%' }} />)}
                </Card>
            </Box>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 4 }} marginTop={5}>
                <Grid item xs={6}>
                    {isDesktop && (
                        <img src={banner_3} width="100%" />
                    ) || (
                            <img src={banner_3_movil} width="100%" />

                        )}
                </Grid>
                <Grid item xs={6} sx={{ position: 'relative' }}>
                    {isDesktop && (
                        <>
                            <Box sx={{
                                position: 'absolute', top: { sm: '58%', xs: '30%' }, bottom: '42%', left: { sm: '87%', lg: '88%' }, fontSize: '5rem', color: 'white',
                                display: { sm: 'block', xs: 'none' }
                            }}>
                                <Iconify fontSize='33px' icon="fa6-solid:arrow-right-long" sx={{
                                    sm: { width: "18px", height: "18px" },
                                    xs: { width: "42px", height: "42px" }, color: "#FFF"
                                }} />
                            </Box>
                            <img src={banner4} width="100%" />
                        </>
                    ) || (
                            <img src={banner4_responsive} width="100%" />
                        )}

                </Grid>
            </Grid>
            {!isDesktop && (
                <Box mt={6}>
                    <Typography variant='subtitle2' fontWeight={500} color='#626262' display='flex' flexDirection='row' justifyContent='space-between'>
                        More about OVERLAP
                        <Iconify icon='eva:arrow-ios-upward-fill' />
                    </Typography>
                </Box>
            )}
        </>

    )
}